import services from "../views/services/index.vue";
import services_create from "../views/services/create.vue";
import services_edit from "../views/services/edit.vue";
import services_detail from "../views/services/detail.vue";
import services_import from "../views/services/import.vue";

const routes = [
  {
    path: "/services",
    name: "services",
    component: services,
    meta: { authOnly: true }
  },
  {
    path: "/services/create",
    name: "services_create",
    component: services_create,
    meta: { authOnly: true }
  },
  {
    path: "/services/edit/:uuid",
    name: "services_edit",
    component: services_edit,
    meta: { authOnly: true }
  },
  {
    path: "/services/detail/:uuid",
    name: "services_detail",
    component: services_detail,
    meta: { authOnly: true }
  },
  {
    path: "/services/import",
    name: "services_import",
    component: services_import,
    meta: { authOnly: true }
  }
];

export default routes;
